import React, { useState, useEffect } from 'react';
import { Nav, Form, InputGroup, OverlayTrigger, Popover, Col, Row } from 'react-bootstrap';
import { ChevronDown, Search, X } from 'react-bootstrap-icons';
import BtnDynamic from '../BtnDynamic';
import utils from '../../../utils';
// import TagDisplay from '../../TagDisplay'; Will add back in once backend is built
import PillsDynamic from '../PillsDynamic';
import LBInput from '../../DesignSystem/LBInput/LBInput';

function SearchComponent({ onQuery, tenantName=null }) {

    const [showPopover, setShowPopover] = useState(false);
    // handles the temp search queries before user presses 'Enter' or 'Tab'
    const [ advTypedQueryObj, setAdvTypedQueryObj ] = useState({
        musts: '',
        shoulds: '',
        must_not:'',
        tags: '',
    })
    // handles the search queries that are submitted by the user after pressing 'Enter' or 'Tab'
    const [ advSearchQueryObj, setAdvSearchQueryObj ] = useState({
        musts: [],
        shoulds: [],
        must_not: [],
        tags: [],
    });

    useEffect(() => {
        // Check if there's a saved search query in local storage   
        if (showPopover) {
            const savedQuery = localStorage.getItem('searchQueryObj');
            if (savedQuery) {   
                setAdvSearchQueryObj(JSON.parse(savedQuery)); // Load the saved query into state
            }
        }  
    }, [showPopover]);

    // Function to handle the submission of the search query
    // This function is triggered when the user presses the search button 
    // It converts the search query object to a JSON string, encodes it, and calls the onQuery function with the encoded query
    // It also clears the input field after submission
    const addKeysToQuery = (e) => {
        e.preventDefault();

        if(e.keyCode === 13) {
            let queryTrimmed = e.target.value
            let sterilizedQuery = JSON.stringify({ query: queryTrimmed });
            let encodedQuery = encodeURIComponent(sterilizedQuery);
            onQuery(encodedQuery);
            e.currentTarget.value = "";
            return;
        } 

        //add a space when the spacebar is pressed
        if(e.keyCode === 32) {
            e.currentTarget.value = e.currentTarget.value + ' ';
        }
    }
        
    // Helper function to update advanced search query in state if 'Enter' or 'Tab' is pressed
    // This function adds the typed query to the advanced search query object that is sent to the SearchResultsPage.js component
    const updateAdvancedQuery = (targetId) => {
        const trimmedQuery = advTypedQueryObj[targetId].trim();
        if (trimmedQuery) {
            setAdvSearchQueryObj((prev) => ({
                ...prev,
                [targetId]: [...prev[targetId], trimmedQuery],
            }));
            // Clear the input field after adding the query
            setAdvTypedQueryObj({
                musts: '',
                shoulds: '',
                must_not:'',
                tags: '',
            })
        }
    };

    // Function to handle changes in the input fields
    // This function updates the corresponding field in the advanced typed query object meaning before 'Enter' or 'Tab' is pressed
    const handleChange = (e) => {
         setAdvTypedQueryObj((prevQuery) => ({
            ...prevQuery,
            [e.target.id]: e.target.value, // Update the specific field in the state
        }));
    };

    // tracks keydown events for the input fields
    // This function handles the Enter and Tab keys to update the advanced search query and adds a space when the spacebar is pressed
    const handleKeyDown = (e) => {
        // add a space when the spacebar is pressed
        if(e.keyCode === 32) {
            setAdvTypedQueryObj((prevQuery) => ({
                ...prevQuery,
                [e.target.id]: advTypedQueryObj[e.target.id] + ' ', // Update the specific field in the state
            }));
        }
        if (e.key === 'Enter' || e.key === 'Tab') {
        e.preventDefault();
            updateAdvancedQuery(e.target.id);
        }
    };

    const addUnsubmittedQueriesToObj = (typedQuery, submittedQuery) => {
        const updatedQueryObj = { ...submittedQuery }; // Create a copy of the submitted query object

        // Iterate through each key in the typed query object
        for (const key in typedQuery) {
            if (typedQuery.hasOwnProperty(key)) {
                const typedValue = typedQuery[key]
                if (typedValue) {
                    updatedQueryObj[key] = [...updatedQueryObj[key], typedValue]; // Add the typed value to the corresponding key in the submitted query object
                }
            }
        }
        return updatedQueryObj; // Return the updated query object
    }

    // Function to handle the submission of the advanced search query
    // This function combines the typed query and the submitted query, and then navigates to the search results page
    const submitAdvancedQuery = (e) => {
        e.preventDefault();
        let objToSend = addUnsubmittedQueriesToObj(advTypedQueryObj, advSearchQueryObj); // Combine typed and submitted queries
    
        // Handle the advanced search query submission here
        // Pass the advanced search query to the to the SearchResultsPage.js component
        const serializedQuery = JSON.stringify(objToSend); // Serialize the query object
        const encodedQuery = encodeURIComponent(serializedQuery); // Encode the serialized query
        onQuery(encodedQuery); // Call the onQuery function with the encoded query

        localStorage.removeItem('searchQueryObj'); // Clear any existing search query in local storage
        localStorage.setItem('searchQueryObj', JSON.stringify(objToSend)); // Store the new search query in local storage
        
        // Clear the input after submission
        setAdvTypedQueryObj({
            musts: '',
            shoulds: '',    
            must_not:'',
            tags: '',
        });
        
        setAdvSearchQueryObj({ // Reset the advanced search query
            musts: [],
            shoulds: [],
            must_not: [],
            tags: [],
        });

        setShowPopover(false); // Close the popover after submission
    }

    const handleClose = () => {
        setAdvTypedQueryObj({
            musts: '',
            shoulds: '',
            must_not:'',
            tags: '',
        }); // Clear the input when the close button is clicked
        setAdvSearchQueryObj({ // Reset the advanced search query
            musts: [],
            shoulds: [],
            must_not: [],
            tags: [],
        });
        localStorage.removeItem('searchQueryObj'); // Clear any existing search query in local storage
        setShowPopover(false); // Close the popover when the close button is clicked
    }

    const handleClearFields = () => {
        setAdvTypedQueryObj({
            musts: '',
            shoulds: '',
            must_not:'',
            tags: '',
        }); // Clear the input when the close button is clicked
        setAdvSearchQueryObj({ // Reset the advanced search query
            musts: [],
            shoulds: [],
            must_not: [],
            tags: [],
        });
        localStorage.removeItem('searchQueryObj'); // Clear any existing search query in local storage
    }


    return (
        <>
            <Nav.Link className="tenant-app-link app-search"> 
                <InputGroup className={tenantName === 'BMGF' ? 'search-margin' : ''}>
                    <InputGroup.Text><Search className='svg-20' /></InputGroup.Text>
                    <Form.Control onKeyUp={(e) => addKeysToQuery(e)} type="text" placeholder="Search news" />
                    <OverlayTrigger
                        placement='bottom'
                        trigger='click'
                        key='bottom'
                        rootClose
                        show={showPopover} // Control visibility with state
                        onToggle={(isVisible) => setShowPopover(isVisible)} // Update state when toggled
                        overlay={
                            <Popover id={`popover-positioned-bottom`} 
                                className='p-06 p-b-end-07 px-width-450 advanced-search-popover border-corner-radius-rounding-04 border-primary-light surface-primary-light' 
                            >
                                <div id="example-collapse-text" className={tenantName}>
                                    <Form>
                                        <Row>
                                            <Col>
                                                <label className='label-small m-b-end-06'>Advanced Search</label>
                                            </Col>
                                            <Col className='align-right'>
                                                <X className='svg-16' onClick={() => handleClose()} /> {/* Close popover */}
                                            </Col>
                                        </Row>
                                        <LBInput 
                                            label="All of these words"
                                            controlId={'musts'}
                                            placeholder={'Type a word or phrase, then press Enter'}
                                            onChange={handleChange}
                                            value={advTypedQueryObj.musts ? advTypedQueryObj.musts : ''} // Show query only if active
                                            onKeyDown={handleKeyDown}
                                        />
                                        <PillsDynamic
                                            pillList={advSearchQueryObj.musts ? advSearchQueryObj.musts : []} 
                                            className={'input-pill-selections border-corner-radius-rounding-08 label-small m-b-start-03'}
                                            handleEdit={(item) => {
                                                // Remove the pill from the list
                                                setAdvSearchQueryObj((prev) => ({
                                                    ...prev,
                                                    musts: prev.musts.filter((pill) => pill !== item),
                                                }));
                                            }}
                                        />
                                        <LBInput 
                                            label="Any of these words"
                                            controlId={'shoulds'}
                                            placeholder={'Type a word or phrase, then press Enter'}
                                            onChange={handleChange}
                                            value={advTypedQueryObj.shoulds ? advTypedQueryObj.shoulds : ''} // Show query only if active
                                            onKeyDown={handleKeyDown}
                                        />
                                        <PillsDynamic
                                            pillList={advSearchQueryObj.shoulds ? advSearchQueryObj.shoulds : []} 
                                            className={'input-pill-selections border-corner-radius-rounding-08 label-small m-b-start-03'}
                                            handleEdit={(item) => {
                                                // Remove the pill from the list
                                                setAdvSearchQueryObj((prev) => ({
                                                    ...prev,
                                                    shoulds: prev.shoulds.filter((pill) => pill !== item),
                                                }));
                                            }}
                                        />
                                        <LBInput
                                            label="None of these words"
                                            controlId={'must_not'}
                                            placeholder={'Type a word or phrase, then press Enter'}
                                            onChange={handleChange}
                                            value={advTypedQueryObj.must_not ? advTypedQueryObj.must_not : ''} // Show query only if active
                                            onKeyDown={handleKeyDown}
                                        />
                                        <PillsDynamic
                                            pillList={advSearchQueryObj.must_not ? advSearchQueryObj.must_not : []} 
                                            className={'input-pill-selections border-corner-radius-rounding-08 label-small m-b-start-03'}
                                            handleEdit={(item) => {
                                                // Remove the pill from the list
                                                setAdvSearchQueryObj((prev) => ({
                                                    ...prev,
                                                    must_not: prev.must_not.filter((pill) => pill !== item),
                                                }));
                                            }}
                                        />
                                        {/*LEAVE---- Backend elasticsearch currently doesn't have this capability --- Will add back in once backend is built */}
                                        {/* <hr className='adv-search-hr'/>
                                        <label className='label-medium m-b-end-03'>Include these tags</label>
                                        <InputDynamic
                                            placeholder={'Search for tags'}
                                            controlId={'tags'} 
                                            className={'input-underline full-width body-small-condensed'}
                                            trackChange={handleKeyDown}
                                            onChange={handleChange}
                                            value={advTypedQueryObj.tags ? advTypedQueryObj.tags : ''} // Show query only if active
                                        />
                                        <TagDisplay 
                                            tagList={advSearchQueryObj.tags ? advSearchQueryObj.tags : []} 
                                            flatList={true}
                                            linksActive={false}
                                            className={'input-tag-selections'}
                                            handleEdit={(item) => {
                                                // Remove the pill from the list
                                                setAdvSearchQueryObj((prev) => ({
                                                    ...prev,
                                                    tags: prev.tags.filter((pill) => pill !== item),
                                                }));
                                            }}
                                        /> */}
                                        <div className={advSearchQueryObj.must_not && advSearchQueryObj.must_not.length > 0 ? 'm-b-start-06 align-right' : 'm-b-start-05 align-right'}>
                                            <BtnDynamic
                                                classes='btn-ghost-lg underline text-secondary-dark m-i-end-04'
                                                actionHandler={handleClearFields}
                                                content={{
                                                    name: 'Clear fields'
                                                }}
                                            />
                                            <BtnDynamic 
                                                classes='surface-brand-primary btn-primary-lg border-corner-radius-rounding-08 p-i-04 p-b-02'
                                                actionHandler={submitAdvancedQuery} 
                                                content={{
                                                    name: 'Search',
                                                    icon: utils.getIcon('search')}
                                              }
                                                loading={false}
                                                idName={'adv-search-submit'}
                                            />
                                        </div>
                                    </Form>
                                </div>
                            </Popover>
                        }
                    >
                        <InputGroup.Text className='search-chevron'><ChevronDown/></InputGroup.Text>
                    </OverlayTrigger>
                </InputGroup>
            </Nav.Link>
        </>
    )
}

export default SearchComponent
